import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

// Cookie banner (UK GDPR / PECR).
// The actual loading of Google, Meta and OpenAI tracking lives in index.html (window.daleyConsent):
//  - Accept  -> Google Consent Mode set to "granted", Meta + OpenAI pixels load.
//  - Decline -> everything stays "denied"; Meta + OpenAI pixels are never loaded.
const CONSENT_KEY = 'daley-cookie-consent'; // 'accepted' | 'declined'

function readConsent() {
  try { return localStorage.getItem(CONSENT_KEY); } catch { return null; }
}

export function reopenCookieBanner() {
  try { localStorage.removeItem(CONSENT_KEY); } catch { /* storage blocked */ }
  window.dispatchEvent(new Event('daley-cookie-reopen'));
}

export default function CookieConsent() {
  // Decide straight away (not after the first render) so the banner appears in the very first paint.
  const [visible, setVisible] = useState(() => !readConsent());

  useEffect(() => {
    const reopen = () => setVisible(true);
    window.addEventListener('daley-cookie-reopen', reopen);
    return () => window.removeEventListener('daley-cookie-reopen', reopen);
  }, []);

  const decide = (choice) => {
    try {
      if (choice === 'accepted') window.daleyConsent?.accept();
      else window.daleyConsent?.decline();
    } catch { /* tracking must never break the site */ }
    try { localStorage.setItem(CONSENT_KEY, choice); } catch { /* storage blocked */ }
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="fixed bottom-0 inset-x-0 z-[60] p-4 md:p-6">
      <div className="max-w-3xl mx-auto bg-navy text-white rounded-[2px] shadow-2xl p-5 md:p-6 flex flex-col md:flex-row md:items-center gap-4">
        <p className="text-sm text-white/80 leading-relaxed flex-1">
          We use essential cookies to make this site work. With your consent, we also use
          analytics and advertising cookies (Google and Meta) to understand how the site is used
          and measure our adverts. See our{' '}
          <Link to="/privacy-policy" className="text-orange underline underline-offset-2 decoration-1 hover:text-white">Privacy Policy</Link>.
        </p>
        <div className="flex gap-3 shrink-0">
          <button
            onClick={() => decide('declined')}
            className="px-4 py-2.5 text-xs font-semibold uppercase tracking-widest border border-white/30 text-white/80 hover:border-white hover:text-white rounded-[2px] transition-colors"
          >
            Decline
          </button>
          <button
            onClick={() => decide('accepted')}
            className="px-5 py-2.5 text-xs font-semibold uppercase tracking-widest bg-orange text-navy rounded-[2px] hover:opacity-90 transition-opacity"
          >
            Accept
          </button>
        </div>
      </div>
    </div>
  );
}
